export const LOGO_FF_BLANC_URL = `${import.meta.env.BASE_URL}/logos/logo_france_frais_connect_blanc_v2.png`;
